import loadingBar from './LoadingBar';

export default loadingBar;



// WEBPACK FOOTER //
// ./src/loadingBar/index.js